exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-country-selector-js": () => import("./../../../src/pages/country-selector.js" /* webpackChunkName: "component---src-pages-country-selector-js" */),
  "component---src-pages-general-error-js": () => import("./../../../src/pages/generalError.js" /* webpackChunkName: "component---src-pages-general-error-js" */),
  "component---src-pages-impressum-js": () => import("./../../../src/pages/impressum.js" /* webpackChunkName: "component---src-pages-impressum-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

